import type { ButtonProps } from "antd";
import i18n from "i18next";
import type { FC } from "react";

import { PrimaryButton } from "../Buttons/components/ActionButton";

export type SearchButtonProps = {
    isDisabled: boolean;
    callback?: () => void;
    htmlType?: ButtonProps["htmlType"];
};

export const SearchButton: FC<SearchButtonProps> = ({ isDisabled, callback, htmlType }) => {
    return (
        <PrimaryButton name="search_button" onClick={callback} disabled={isDisabled} htmlType={htmlType}>
            {i18n.t("button.search")}
        </PrimaryButton>
    );
};
